import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Contact from "./pages/Contact";
import Reports from "./pages/Reports";
import { AuthCallback } from "./components/admin/AuthCallback";
import { LangProvider } from "./lib/i18n";
import { IntroSplash } from "./components/site/brand/IntroSplash";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    {location.pathname === "/" && <IntroSplash />}
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/reports" element={<Reports />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <LangProvider>
    <BrowserRouter>
      <AppRouter />
      <Toaster theme="dark" position="bottom-right" richColors />
    </BrowserRouter>
    </LangProvider>
  );
}

export default App;
